import styled from 'styled-components';
import {AI_BRAND_GRADIENT_VERTICAL} from '../../../aiMessageGenerator/aiGeneratorButton/AIGeneratorButton.css';
import {PROMPT_TEXTAREA_MAX_HEIGHT_PX} from '../../../aiMessageGenerator/AIMessageGenerator.css';
import {dFlex, dFlexColumn, dFlexCenter, dFlexBetween, alignCenter, alignStretch} from '../../../../globalVariables/GlobalFlex';

export const container = styled.div`
    ${dFlexColumn}
    ${alignStretch}
    gap: var(--space-lg);
    padding: var(--space-sm);
    border: 1px solid var(--color-border-subtle);
    border-radius: var(--border-radius-border-radius-2xl);
    box-shadow: 0 2px 6px -3px rgba(0, 0, 0, 0.28);
    background: var(--color-bg-base);
    flex-shrink: 0;
    margin-top: var(--space-sm);
`;

export const fileAttachmentPreview = styled.div`
    position: relative;
    ${dFlexCenter}
    gap: var(--space-sm);
    width: 214px;
    max-width: 100%;
    height: 48px;
    padding: var(--space-xs) var(--space-sm);
    border: 1px solid var(--color-border-subtle);
    border-radius: var(--border-radius-border-radius-md, 8px);
    background: var(--color-bg-surface-default);
    box-sizing: border-box;
`;

export const fileAttachmentName = styled.span`
    flex: 1;
    min-width: 0;
    font-size: var(--font-size-caption);
    line-height: 16px;
    color: var(--color-text-default);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: start;
`;

export const attachmentRow = styled.div`
    ${dFlex}
    ${alignCenter}
    padding-inline-start: var(--space-md);
    padding-top: var(--space-md);
`;

export const attachmentPreview = styled.div`
    position: relative;
    width: 48px;
    height: 48px;
    flex-shrink: 0;
`;

export const attachmentImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: var(--border-radius-border-radius-md, 8px);
`;

export const removeAttachmentButton = styled.button`
    position: absolute;
    inset-inline-end: -12px;
    top: -12px;
    width: 24px;
    height: 24px;
    padding: 0;
    border: none;
    border-radius: 100px;
    background: var(--color-text-default);
    cursor: pointer;
    ${dFlexCenter}
`;

export const promptTextarea = styled.textarea`
    width: 100%;
    border: none;
    resize: none;
    overflow: hidden;
    box-sizing: border-box;
    min-height: 20px;
    max-height: ${PROMPT_TEXTAREA_MAX_HEIGHT_PX}px;
    padding: var(--space-sm) var(--space-lg);
    font-size: var(--font-size-body);
    font-family: inherit;
    line-height: 1.2;
    color: var(--color-text-default);
    background: transparent;
    text-align: start;

    &::placeholder {
        color: var(--color-text-subtle);
    }

    &:focus {
        outline: none;
    }
`;

export const actionsRow = styled.div`
    ${dFlexBetween}
    width: 100%;
`;

const iconButton = styled.button`
    width: 32px;
    height: 32px;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    ${dFlexCenter}
    flex-shrink: 0;

    &:disabled {
        cursor: default;
    }
`;

export const sendButton = styled(iconButton)<{$disabled?: boolean}>`
    border-radius: 100px;
    background: ${AI_BRAND_GRADIENT_VERTICAL};
    opacity: ${p => (p.$disabled ? 0.3 : 1)};

    &:not(:disabled):hover {
        opacity: 0.9;
    }
`;

export const hiddenFileInput = styled.input`
    display: none;
`;
